<template lang="pug">
  v-btn(
    color="primary"
    @click="candidatesZoomRegistrant"
    :disabled="disabled"
    outlined
    small
  ) Add to Zoom webinar
</template>

<script>
import errorsMixin from '@/mixins/errors.mixin';
import apiCourses from '@/services/api/api-courses';
import courseService from '@/app/admin/models/courseService.js';

export default {
  mixins: [errorsMixin],

  props: {
    disabled: Boolean,
    courseID: Number,
    activeItems: Array,
  },

  data: () => ({
    actionsService: new courseService(apiCourses)
  }),

  methods: {
    async candidatesZoomRegistrant() {
      try {
        const candidatesIDS = this.activeItems.map(item => item.ID);
        let res = await this.actionsService.candidatesZoomRegistrantBulk(this.courseID, candidatesIDS)
        this.$notify({text: 'Setting zoom presentie', type: 'success'})
      } catch (err) {
        this.processError(err)
      }
    }
  },
}
</script>
